import * as React from 'react';
import { Link } from 'react-router-dom';
import { ImageWithCaption } from '@emorg-prd/standard-react';
import { Alert, Button, Grid } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import NewConnectedPORInfoImage from '../../../images/newConnectedPORInfoImage.png';
import './NewAWSPORInfoModal.css';

interface NewAWSPORInfoModalProps {
    visible: boolean;
    onClose: () => any;
}


const NewAWSPORInfoModal = ({ visible, onClose }: NewAWSPORInfoModalProps) => {

    return (
        <StandardModal
            show={visible}
            onDismiss={onClose}
            title="New Connected Port Opening Request"
            optionalClass="aws-por-info-modal"
            footer={
                <Grid variant="2up">
                    <Grid.Item>
                        <Button variant="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </Grid.Item>
                    <Grid.Item>
                        <Link to="/awsPortOpeningRequest/new" className="redirect-button">
                            <Button variant="primary" optionalClass="redirect-button">
                                Go to the Request Form
                            </Button>
                        </Link>
                    </Grid.Item>
                </Grid>
            }
        >
            <Alert
                variant="warning"
                body="For AWS Port Opening Requests please go to the Request Form page and follow the instructions in the image below."
            />
            <ImageWithCaption
                src={NewConnectedPORInfoImage}
                caption=""
                alt="NewConnectedPORInfoImage"
            />
        </StandardModal>
    );
}

export default NewAWSPORInfoModal;